import { Component, Input } from '@angular/core';
import { IEbComponent } from "../entitybuilder/entitybuilder.component";
import { ComponentService } from "../../services/component-service.service";

@Component({
    templateUrl: "./number.component.html",
    standalone: false
})
export class NumberComponent implements IEbComponent {
    @Input() title: string;
    @Input() data: any;
    @Input() parent?: string;
    @Input() isArray?: boolean;

    constructor(public componentService: ComponentService) {
    }

    delete() {
        var serviceObj: any = {
            name: this.title,
            data: this.data,
        }
        if (this.parent) {
            serviceObj.parent = this.parent;
        }
        this.componentService.deleteObject(serviceObj);
    }

    edit() {
        const serviceObj: any = {
            name: this.title,
            data: this.data,
        }
        if (this.parent) {
            serviceObj.parent = this.parent;
        }
        this.componentService.editObject(serviceObj);
    }
}
